import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const logo = css`
  block-size: ${spacing(4.5)};
`

export const wrapper = {
  header: css`
    margin-block-end: ${spacing(2)};
  `,
  logo: css`
    inline-size: ${spacing(5)};
  `,
  block: css`
    inline-size: ${spacing(66.75)};
    margin-inline-start: auto;
    margin-block-end: ${spacing(2)};
  `,
  verticals: css`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: ${spacing(0.5)};
  `,
  tabs: css`
    margin-block-end: ${spacing(2)};
  `,
}
